// Prijevodi za Beton modul (UI + Excel exporti). Podaci se NE prevode.
const dict = {
  HR: {
    // Excel sheet nazivi
    sheetDeliveryNote: 'Otpremnica',
    sheetDeliveryNotes: 'Otpremnice',
    sheetMaterialConsumption: 'Utrošak materijala',
    sheetPlants: 'Betonare',
    // Excel / kolone
    customer: 'Kupac',
    deliveryNote: 'Otpremnica',
    order: 'Nalog',
    quantity: 'Količina',
    quantityM3: 'Količina (m3)',
    constructionSite: 'Gradilište',
    driver: 'Vozač',
    regPlate: 'Registracija',
    recipe: 'Receptura',
    recipeCode: 'Šifra recepture',
    mixingTime: 'Vrijeme završetka miješanja',
    cancelled: 'Storno',
    cancelledValue: 'DA',
    companyName: 'Naziv firme',
    plantName: 'Naziv betonare',
    totalM3: 'Ukupno m3',
    period: 'Razdoblje',
    date: 'Datum',
    time: 'Vrijeme',
    // komponente (prefiks + sufiks za Excel kolone)
    aggPrefix: 'Agr',
    cemPrefix: 'Cem',
    addPrefix: 'Adi',
    cName: 'naziv',
    cCode: 'sifra',
    cTarget: 'zadano',
    cDosed: 'dozirano',
    water: 'Voda',
    wTarget: 'zadano',
    wDosed: 'dozirano',
    wAdded: 'naknadno',
    wCorrection: 'korekcija',
    // dialog / prikaz
    materialConsumption: 'Utrošak materijala',
    article: 'Artikl',
    codeShort: 'Šifra',
    targetShort: 'Zadano',
    dosedShort: 'Dozirano',
    aggregates: 'Agregati',
    cements: 'Cementi',
    additives: 'Aditivi',
    waterAdded: 'Naknadno',
    waterCorrection: 'Korekcija',
    storno: 'STORNO',
    // Home / kartice / lista
    totalProduction: 'Ukupna proizvodnja za',
    customerHead: 'Kupac',
    conSite: 'Gradilište',
    toExcel: 'U Excel',
    setDate: 'Postavi datum',
    refresh: 'Osvježi',
    totalAllPlants: 'Ukupno sve betonare',
    listTitle: 'Lista beton otpremnica',
    search: 'Pretraga',
    dateFrom: 'Od datuma',
    dateTo: 'Do datuma',
    selectCustomer: 'Odaberi kupca',
    selectConSite: 'Odaberi gradilište'
  },
  EN: {
    sheetDeliveryNote: 'Delivery note',
    sheetDeliveryNotes: 'Delivery notes',
    sheetMaterialConsumption: 'Material consumption',
    sheetPlants: 'Plants',
    customer: 'Customer',
    deliveryNote: 'Delivery note',
    order: 'Order',
    quantity: 'Quantity',
    quantityM3: 'Quantity (m3)',
    constructionSite: 'Construction site',
    driver: 'Driver',
    regPlate: 'Reg. plate',
    recipe: 'Recipe',
    recipeCode: 'Recipe code',
    mixingTime: 'Mixing completion time',
    cancelled: 'Storno',
    cancelledValue: 'YES',
    companyName: 'Company name',
    plantName: 'Plant name',
    totalM3: 'Total m3',
    period: 'Period',
    date: 'Date',
    time: 'Time',
    aggPrefix: 'Agg',
    cemPrefix: 'Cem',
    addPrefix: 'Add',
    cName: 'name',
    cCode: 'code',
    cTarget: 'target',
    cDosed: 'dosed',
    water: 'Water',
    wTarget: 'target',
    wDosed: 'dosed',
    wAdded: 'added',
    wCorrection: 'correction',
    materialConsumption: 'Material consumption',
    article: 'Article',
    codeShort: 'Code',
    targetShort: 'Target',
    dosedShort: 'Dosed',
    aggregates: 'Aggregates',
    cements: 'Cements',
    additives: 'Additives',
    waterAdded: 'Added',
    waterCorrection: 'Correction',
    storno: 'STORNO',
    totalProduction: 'Total production for',
    customerHead: 'Customer',
    conSite: 'Construction site',
    toExcel: 'To Excel',
    setDate: 'Set a date',
    refresh: 'Refresh',
    totalAllPlants: 'Total all plants',
    listTitle: 'Beton delivery notes list',
    search: 'Search',
    dateFrom: 'Date from',
    dateTo: 'Date to',
    selectCustomer: 'Select customer',
    selectConSite: 'Select construction site'
  }
}

export function betonT (lang) {
  return dict[lang === 'HR' ? 'HR' : 'EN']
}
